import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Card, Form, Alert, Button } from 'react-bootstrap';
const forEach = require('lodash/forEach');
const find = require('lodash/find');

const ServerRequest = require('../../actions/request');
const GlobalUserActions = require('../../actions/GlobalUserActions');
import OpenIdProviderSelector from './OpenIdProviderSelector';

const propTypes = {
    user: PropTypes.object.isRequired,
    openIdProviders: PropTypes.array.isRequired,
};

const defaultProps = {};

const columnInfo = {
    id: {
        title: 'ID',
        hidden: true
    },
    created_at: {
        title: 'Created At',
        hidden: true
    },
    op_id: {
        title: 'OpenId Provider ID',
        editable: true, // use OpenIdProviderSelector
    },
    iss: {
        title: 'Issuer',
        fromOp: true,
    },
    description: {
        title: 'Description',
        fromOp: true,
    },
    aud: { 
        title: 'Client ID (aud)',
        editable: true,
    },
//    platform_url: { 
//        title: 'Platform URL',
//        editable: true,
//    },
    deployment_id: { 
        title: 'Deployment ID',
        editable: true,
    },
    oidc_auth_url: { 
        title: 'OIDC Auth URL',
        editable: true,
    },
    access_token_url: {
        title: 'OAuth2 Access Token URL',
        editable: true,
    },
    jwks_url: { 
        title: 'JWKS URL',
        editable: true,
    },
    archived: {
        title: 'Archived',
        hidden: true
    },
};

class AdminUserLmsDeploymentEditor extends React.Component {
    constructor(props) {
        super(props);
        const op = find(props.openIdProviders, { id: String(props.deployment.op_id) });
        this.state = {
            ...this.getStateFromProps(props,op),
            canEdit: false,
            anythingChanged: false,
            lmsDeploymentMessageVisible: false,
            lmsDeploymentMessageState: '',
            lmsDeploymentMessage: '',
        };
        
    }
    
    getStateFromProps=(props, op)=>{
        if (!op) {
            op={};
        }
        var s = {};
        forEach(columnInfo,(v,k)=>{
            if (v.fromOp) {
                s[k] = op[k];
            }
            else {
                s[k] = props.deployment[k];
            }
        });
        s.options = { ...(props.deployment.options || {}) };
        return s;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        var op;
        if (nextProps.deployment.op_id !== this.props.deployment.op_id) {
            // external change updated the op.
            op = find(nextProps.openIdProviders,{ id: String(nextProps.deployment.op_id) });
        }
        else {
            op = find(nextProps.openIdProviders,{ id: String(this.state.op_id) });
        }

        this.setState ({
            ...this.getStateFromProps(nextProps, op),
            canEdit: false,
            anythingChanged: false,
            lmsDeploymentMessageVisible: false,
            lmsDeploymentMessageState: '',
            lmsDeploymentMessage: ''
        });
    }

    updateCanEdit=(e)=>{
        this.setState({ canEdit: !this.state.canEdit })
    }

    updateDeployment=(e)=>{
        const recordId = this.props.deployment.id;
        const changes = {
            op_id: this.state.op_id,
            platform_url: this.state.platform_url,
            deployment_id: this.state.deployment_id,
            aud: this.state.aud,
            oidc_auth_url: this.state.oidc_auth_url,
            access_token_url: this.state.access_token_url,
            jwks_url: this.state.jwks_url,
            options: this.state.options,
        };
        
        if (confirm("Are you sure you want to update the deployment data?")) {
            this.setState({ anythingChanged: false }, () => { // disable the update button while we're sending the update
                ServerRequest.makeRequest((`/authoring/user/${this.props.user.id}/update/lms_deployment`), 'POST', JSON.stringify({
                        userId: this.props.user.id,
                        recordId: recordId,
                        changes: changes
                    }))
                    .then((res) => {
                        this.setState({
                            lmsDeploymentMessageVisible:true,
                            lmsDeploymentMessageState: 'success',
                            lmsDeploymentMessage: 'LMS Deployment Updated',
                        });
                    })
                    .catch((err) => {
                        console.log("error", err)
                        this.setState({
                            lmsDeploymentMessageVisible:true,
                            lmsDeploymentMessageState: 'danger',
                            lmsDeploymentMessage: 'There was a problem updating the LMS Deployment',
                        });
                    });
            });
        }
    }

    deleteDeployment=(e)=>{
        if (confirm("Are you sure you want to delete the LMS deployment?")) {
            ServerRequest.makeRequest((`/authoring/user/${this.props.user.id}/delete/lms_deployment`), 'POST', JSON.stringify({
                    recordId: this.props.deployment.id
                }))
                .then((res) => {
                    console.log("updated")
                    GlobalUserActions.getLmsDeployments(uuid.v4(), this.props.user.id); // trigger an update
                })
                .catch((err) => { console.log("error", err); });
        }
    }
    
    onChange=(key, value)=>{
        const changes = {};
        changes[key] = value;
        let anythingChanged = false;
        forEach(columnInfo,(v,k)=>{
            if (v.editable) {
                const state_val = (key === k) ? value : this.state[k];
                if (this.props.deployment[k] !== state_val) {
                    anythingChanged = true;
                }
            }
        })
        changes.anythingChanged = anythingChanged;
        this.setState(changes);
    }

    onOptionsChange=(key, value)=>{
        this.setState({
            options: { ...this.state.options, [key]: value },
            anythingChanged: true,
        });
    }

    render() {
        var entries = [];
        let formStyle={};
        if (this.state.canEdit) {
            formStyle = { display: 'block' };
        }
        forEach(columnInfo,(v, k)=>{
            if (!v.hidden) {
                if (k === 'op_id') {
                    if (this.state.openIdProviders && this.state.openIdProviders.length) {
                        entries.push(
                            <OpenIdProviderSelector key={k}
                                id={`admin-lms-deployment-op-id-selector-${this.props.deployment.id}`}
                                openIdProviders={this.state.openIdProviders}
                                onSelect={(val)=>{this.onChange('op_id',val)}}
                            />
                        );
                    }
                }
                else {
                    entries.push (
                        <Form.Group key={k} controlId={`admin-${k}`} style={formStyle}>
                            <Form.Label>{v.title}</Form.Label>
                            <Form.Control
                                type="text"
                                className="min-width-url"
                                aria-label={v.title}
                                value={this.state[k]||''}
                                onChange={(e)=>{ if (v.editable) { this.onChange(k,e.target.value)} } }
                                disabled={!this.state.canEdit || !v.editable}
                            />
                        </Form.Group>
                    );
                }
            }
        })
        
        return (
            <div className="lms-deployment-editor">
                <Card body bg="light">
                    {entries}

                    <Form.Group
                        controlId={`admin-lineitem-tag-options-${this.props.deployment.id}`}
                        style={{ ...formStyle, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '0.75em' }}
                    >
                        <Form.Label
                            className="mb-0"
                            title={'Prefixes score category tags (e.g. "1" becomes "<prefix>1") when searching for/creating lineitems. Leave blank unless this platform\'s own default lineitem collides with a bare category tag.'}
                        >
                            Tag Prefix
                        </Form.Label>
                        <Form.Control
                            type="text"
                            size="sm"
                            style={{ width: '8em' }}
                            aria-label="Score Category Tag Prefix"
                            value={this.state.options.tag_prefix || ''}
                            onChange={(e)=>{ this.onOptionsChange('tag_prefix', e.target.value); }}
                            disabled={!this.state.canEdit}
                        />
                        <Form.Check
                            className="mb-0"
                            type="checkbox"
                            label="Auto-correct default/category tag collisions"
                            title={'When a score category resolves to the same lineitem as the platform\'s default, retag the shared lineitem to "grade" and create a separate lineitem for that category. Safe to disable once the platform-side data no longer needs correcting.'}
                            checked={!!this.state.options.fix_default_lineitem_tag_collision}
                            onChange={(e)=>{ this.onOptionsChange('fix_default_lineitem_tag_collision', e.target.checked); }}
                            disabled={!this.state.canEdit}
                        />
                        <Form.Check
                            className="mb-0"
                            type="checkbox"
                            label="Ensure dedicated 'grade' default lineitem"
                            title={'Some platforms adopt whatever lineitem we create for a score category as their own reported default on later launches, which then collides with that category. When enabled, use (or create, if missing) a lineitem tagged "grade" as our default instead of trusting the platform-reported one.'}
                            checked={!!this.state.options.ensure_grade_lineitem}
                            onChange={(e)=>{ this.onOptionsChange('ensure_grade_lineitem', e.target.checked); }}
                            disabled={!this.state.canEdit}
                        />
                    </Form.Group>

                    <Button onClick={this.updateCanEdit}>
                        <i className={!this.state.canEdit ? 'fa fa-lock' : 'fa fa-unlock-alt'} aria-hidden="true"></i>
                    </Button>

                    <Button onClick={this.updateDeployment} disabled={!this.state.anythingChanged}>
                        Update
                    </Button>

                    <Button onClick={this.deleteDeployment}>
                        Delete
                    </Button>
                </Card>
                { this.state.lmsDeploymentMessageVisible &&
                    <Alert variant={this.state.lmsDeploymentMessageState}>
                        <h4>{this.state.lmsDeploymentMessage}</h4>
                    </Alert>
                }
            </div>
        );
    }
}

AdminUserLmsDeploymentEditor.propTypes = propTypes;
AdminUserLmsDeploymentEditor.defaultProps = defaultProps;

export default AdminUserLmsDeploymentEditor;